import {Controller} from "stimulus"

let draggable
let ghostElement

export default class extends Controller {

    static targets = ["tab", "panel"]

    connect() {
    }

    switchTab(e) {
        const delegateId = e.currentTarget.dataset.delegateId;

        this.panelTargets.forEach((panel) => {
            panel.classList.toggle("hidden", panel.dataset.delegateId !== delegateId);
        });

        this.tabTargets.forEach((tab) => {
            const active = tab.dataset.delegateId === delegateId;
            tab.setAttribute("aria-selected", active);
            tab.classList.toggle("bg-unicyan-700", active);
            tab.classList.toggle("text-white", active);
            tab.classList.toggle("bg-gray-100", !active);
            tab.classList.toggle("text-gray-700", !active);
            tab.classList.toggle("hover:bg-gray-200", !active);
            tab.classList.toggle("hover:text-gray-900", !active);

            const count = tab.querySelector(".tab-count");
            if (count) {
                count.classList.toggle("bg-white/20", active);
                count.classList.toggle("text-white", active);
                count.classList.toggle("bg-white", !active);
                count.classList.toggle("text-gray-700", !active);
            }
        });
    }

    disconnect() {
        document.removeEventListener('touchmove', handleTouchMove);
        if (ghostElement) {
            ghostElement.remove();
            ghostElement = null;
        }
        draggable = null;
    }

    dragTask(e) {
        const item = e.target.closest(".task-item")
        if (!item) return;
        item.classList.add("opacity-30")
        draggable = item
    }

    touchTask(e) {
        e.preventDefault();
        draggable = e.target.closest(".task-item")
        if (!draggable) return;
        ghostElement = draggable.cloneNode(true);
        ghostElement.classList.add("opacity-50", "fixed", "pointer-events-none", "z-50");
        document.body.appendChild(ghostElement);

        const touch = e.touches[0];
        ghostElement.style.left = (touch.clientX - 5) + 'px';
        ghostElement.style.top = (touch.clientY - ghostElement.offsetHeight / 2) + 'px';

        document.addEventListener('touchmove', handleTouchMove, {passive: false});
    }

    dragStopTask(e) {
        const item = e.target.closest(".task-item")
        if (item) item.classList.remove("opacity-30")
        document.removeEventListener('touchmove', handleTouchMove);

        if (ghostElement) {
            ghostElement.remove();
            ghostElement = null;
        }
        draggable = null;
    }

    onAssignable(e) {
        e.preventDefault();
        return true;
    }

    taskAssignable(e) {
        const target = e.currentTarget;
        target.classList.add("animate-pulse")
        setTimeout(function () {
            target.classList.remove("animate-pulse");
        }, 3000);
        return true;
    }

    leaveAssignable(e) {
        e.currentTarget.classList.remove("animate-pulse")
    }

    assignTouchedTask(e) {
        e.preventDefault();
        if (!draggable) return;

        const touch = e.changedTouches[0];
        const lastTouchedElement = document.elementFromPoint(touch.clientX, touch.clientY);
        document.removeEventListener('touchmove', handleTouchMove);

        if (ghostElement) {
            ghostElement.remove();
            ghostElement = null;
        }

        if (lastTouchedElement) {
            const column = this.dropColumn(lastTouchedElement);
            if (column) moveTaskToColumn(column, draggable);
        }
        draggable = null;
    }

    assignTask(e) {
        e.preventDefault();
        if (!draggable) return;

        const column = this.dropColumn(e.target);
        if (column) moveTaskToColumn(column, draggable);
        draggable = null;
    }

    // A task may be dropped on a column (Unassigned box or the visible panel)
    // or on a member's tab; a tab drop resolves to that member's panel.
    dropColumn(element) {
        const column = element.closest(".delegate-column");
        if (column) return column;

        const tab = element.closest(".task-delegator-tab");
        if (!tab) return null;
        return this.panelTargets.find((panel) => panel.dataset.delegateId === tab.dataset.delegateId);
    }
}

function moveTaskToColumn(column, taskElement) {
    const delegateId = column.dataset.delegateId;
    const taskId = taskElement.dataset.taskId;
    const originalParent = taskElement.parentElement;
    column.querySelector(".delegate-tasks").prepend(taskElement);
    updateTaskAssignment(delegateId, taskId, taskElement, originalParent);
    taskElement.classList.remove("opacity-30");
    taskElement.classList.add("animate-pulse");
    setTimeout(function () {
        taskElement.classList.remove("animate-pulse");
    }, 1000);
}

function updateTaskAssignment(delegateId, taskId, taskElement, originalParent) {
    fetch(`/task_delegator/${taskId}/assign`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
            delegate_id: delegateId === "0" ? "" : delegateId
        })
    })
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => { throw data; });
            }
            return response.json();
        })
        .then(() => {
            updateColumnCounts();
        })
        .catch(error => {
            if (originalParent) {
                originalParent.prepend(taskElement);
            }
            updateColumnCounts();
            alert(error.error || "Failed to assign task. Please reload the page.");
        });
}

function updateColumnCounts() {
    document.querySelectorAll(".delegate-column").forEach((column) => {
        const delegateId = column.dataset.delegateId;
        const count = column.querySelectorAll(".task-item").length;
        document.querySelectorAll(`[data-count-for="${delegateId}"]`).forEach((el) => {
            el.textContent = count;
        });
    });
}

function handleTouchMove(e) {
    const touch = e.touches[0];

    if (ghostElement) {
        ghostElement.style.left = (touch.clientX - 5) + 'px';
        ghostElement.style.top = (touch.clientY - ghostElement.offsetHeight / 2) + 'px';
    }

    const viewportHeight = window.innerHeight;
    const scrollTriggerDistance = 100;

    if (touch.clientY > viewportHeight - scrollTriggerDistance) {
        window.scrollBy(0, 10);
    }

    if (touch.clientY < scrollTriggerDistance) {
        window.scrollBy(0, -10);
    }

    e.preventDefault();
}
